var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path0, _path1, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdTypeDisplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 84,
    viewBox: "0 0 110 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56700_9602)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 84,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41577 13.3037H55.9059C61.3945 13.3037 68.7409 17.1591 71.8097 22.5089C92.0738 57.8349 112.327 93.1422 132.756 128.756C135.825 134.106 132.902 137.961 127.414 137.961H78.9235C73.4349 137.961 66.0886 134.106 63.0197 128.756C42.388 92.7893 22.0462 57.3278 2.07293 22.5089C-0.995904 17.1591 1.92722 13.3037 7.41577 13.3037Z",
    fill: "#8991DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.51767 15.7696L5.51578 22.2403L8.51509 18.7268L4.69046 11.2138L1.51767 15.7696Z",
    fill: "#8991DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4644 9.00002H58.9545C64.4431 9.00002 71.7894 12.8555 74.8583 18.2053C95.1224 53.5312 115.376 88.8386 135.805 124.452C138.874 129.802 135.951 133.658 130.462 133.658H81.9721C76.4835 133.658 69.1371 129.802 66.0683 124.452C45.4366 88.4856 25.0948 53.0241 5.12151 18.2053C2.05268 12.8555 4.9758 9.00002 10.4644 9.00002Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8053 9.59428H59.2955C64.7841 9.59428 71.4451 13.4497 74.1732 18.2057C94.561 53.7472 114.567 88.6226 135.12 124.453C137.848 129.209 135.61 133.064 130.122 133.064H81.6317C76.1431 133.064 69.4821 129.209 66.754 124.453C46.0009 88.2743 25.9016 53.2357 5.8072 18.2057C3.07905 13.4497 5.3168 9.59428 10.8053 9.59428Z",
    fill: "url(#paint0_linear_56700_9602)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.495 12.9616C44.7244 12.9616 44.8179 12.8002 44.7037 12.6013C44.5896 12.4023 44.3111 12.2409 44.0816 12.2409C43.8522 12.2409 43.7588 12.4023 43.8729 12.6013C43.9871 12.8002 44.2656 12.9616 44.495 12.9616Z",
    fill: "#E8E8E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7052 13.068H34.3927C34.0964 13.068 33.7344 12.8583 33.587 12.6014C33.4396 12.3444 33.5611 12.1348 33.8573 12.1348H40.1698C40.4661 12.1348 40.8281 12.3444 40.9755 12.6014C41.1229 12.8583 41.0014 13.068 40.7052 13.068Z",
    fill: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56700_9602",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 11,
    width: 127,
    height: 120
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32481 18.1751C8.38592 18.294 8.451 18.4138 8.5201 18.5342L69.0894 124.123C71.253 127.895 76.5357 130.953 80.8888 130.953H128.625C132.978 130.953 134.753 127.895 132.59 124.123L72.0204 18.5342C72.012 18.5195 72.0035 18.5048 71.9949 18.49C69.8155 14.7386 64.557 11.7048 60.2211 11.7048H50.8168C50.2785 11.7048 49.9988 12.046 50.3276 12.6192C50.4088 12.7606 50.7633 13.3907 50.8291 13.5293C51.608 15.1693 50.9155 16.233 49.1717 16.233H28.7287C27.0171 16.233 25.1357 15.2152 24.025 13.6109C23.9108 13.4459 23.5239 12.7885 23.4267 12.6192C23.0979 12.046 22.4947 11.7048 21.8885 11.7048H12.4843C10.5203 11.7048 9.08113 12.3273 8.29172 13.3569C7.98762 13.7536 7.77994 14.2106 7.67584 14.7158C7.47037 15.713 7.66838 16.8976 8.32481 18.1751Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56700_9602)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.4997,
    height: 139.705,
    rx: 2.74856,
    transform: "matrix(1 0 0.49758 0.867418 4.10352 10.8876)",
    fill: "#DDE3E9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.5446,
    height: 22.9477,
    rx: 1.88365,
    transform: "matrix(1 0 0.49758 0.867418 16.5364 24.2482)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.5446,
    height: 22.9477,
    rx: 1.88365,
    transform: "matrix(1 0 0.49758 0.867418 29.6294 48.3801)",
    fill: "url(#paint1_linear_56700_9602)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.5446,
    height: 22.9477,
    rx: 1.88365,
    transform: "matrix(1 0 0.49758 0.867418 44.1306 72.3526)",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4233 16.2036C66.2064 15.9321 65.7936 15.9321 65.5767 16.2036L61.1195 21.7828C60.8361 22.1376 61.0887 22.6628 61.5428 22.6628H64.4288V26.7393C64.4288 27.0385 64.6714 27.2811 64.9706 27.2811H67.0294C67.3286 27.2811 67.5712 27.0385 67.5712 26.7393V22.6628H70.4572C70.9113 22.6628 71.1639 22.1376 70.8805 21.7828L66.4233 16.2036Z",
    fill: "#8991DC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3386 4.1629C47.1651 3.9457 46.8349 3.9457 46.6614 4.1629L43.0956 8.62628C42.8689 8.91012 43.0709 9.33024 43.4342 9.33024H45.7431V12.5915C45.7431 12.8308 45.9371 13.0249 46.1765 13.0249H47.8235C48.0629 13.0249 48.2569 12.8308 48.2569 12.5915V9.33024H50.5658C50.9291 9.33024 51.1312 8.91012 50.9044 8.62628L47.3386 4.1629Z",
    fill: "#8991DC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1349 26.3054C56.8096 25.8982 56.1904 25.8982 55.8651 26.3054L49.1793 34.6743C48.7541 35.2065 49.133 35.9942 49.8142 35.9942H54.1432V42.109C54.1432 42.5578 54.5071 42.9217 54.9559 42.9217H58.0441C58.4929 42.9217 58.8568 42.5578 58.8568 42.109V35.9942H63.1858C63.867 35.9942 64.2459 35.2065 63.8207 34.6743L57.1349 26.3054Z",
    fill: "#8991DC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5582 32.5091C86.016 31.8303 84.984 31.8303 84.4418 32.5091L73.2988 46.4571C72.5902 47.3441 73.2217 48.657 74.357 48.657H81.5721V58.8483C81.5721 59.5964 82.1785 60.2028 82.9265 60.2028H88.0735C88.8215 60.2028 89.4279 59.5964 89.4279 58.8483V48.657H96.643C97.7783 48.657 98.4098 47.3441 97.7012 46.4571L86.5582 32.5091Z",
    fill: "#413993"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 107,
    height: 81,
    rx: 1.5,
    stroke: "#413993",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56700_9602",
    x1: 32.4424,
    y1: 9.00003,
    x2: 16.4971,
    y2: 222.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6C1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8991DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_56700_9602",
    x1: 0,
    y1: 11.4738,
    x2: 53.5446,
    y2: 11.4738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6C1EE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56700_9602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 84,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdTypeDisplay);
export default __webpack_public_path__ + "static/media/adType_display.785bbcc27d367279b10efe1237c00880.svg";
export { ForwardRef as ReactComponent };